import React from 'react';

const ITTechnology = () => {
  return (
    <div className="page">
      <h1>IT & Technology Solutions</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default ITTechnology; 